import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=08bc5524&scoped=true&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"
import style0 from "./Brand.vue?vue&type=style&index=0&id=08bc5524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc5524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08bc5524')) {
      api.createRecord('08bc5524', component.options)
    } else {
      api.reload('08bc5524', component.options)
    }
    module.hot.accept("./Brand.vue?vue&type=template&id=08bc5524&scoped=true&", function () {
      api.rerender('08bc5524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Brand.vue"
export default component.exports